/**
 * Staggered scroll reveal
 * =======================
 * Adds `.is-visible` to a container once it scrolls into view, and sets a
 * `--reveal-index` custom property on each child so CSS can stagger them
 * with `transition-delay`.
 *
 * To animate a new list, add an entry to `TARGETS` and give the container /
 * items the matching styles (see `_hero.scss` for the pattern).
 */
( function() {
	'use strict';

	const TARGETS = [
		{ list: '.hero-widget__usps', item: '.usp-box', widget: 'db_hero' },
		{ list: '.text-widget__icon-list', item: '.icon-box', widget: 'db_text' },
	];

	const VISIBLE_CLASS = 'is-visible';

	function reveal( list, itemSelector ) {
		list.querySelectorAll( itemSelector ).forEach( ( item, index ) => {
			item.style.setProperty( '--reveal-index', index );
		} );

		list.classList.add( VISIBLE_CLASS );
	}

	function initStaggerReveal() {
		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		const canObserve = 'IntersectionObserver' in window;

		let observer = null;

		if ( canObserve && ! prefersReducedMotion ) {
			observer = new IntersectionObserver( ( entries, obs ) => {
				entries.forEach( ( entry ) => {
					if ( ! entry.isIntersecting ) {
						return;
					}

					reveal( entry.target, entry.target.dataset.revealItem );

					// Reveal once, then stop watching.
					obs.unobserve( entry.target );
				} );
			}, {
				threshold: 0.25,
				rootMargin: '0px 0px -10% 0px',
			} );
		}

		TARGETS.forEach( ( { list, item } ) => {
			document.querySelectorAll( list ).forEach( ( el ) => {
				// Already handled (e.g. re-init after an Elementor edit).
				if ( el.classList.contains( VISIBLE_CLASS ) ) {
					return;
				}

				// No animation wanted or possible — show immediately.
				if ( ! observer ) {
					reveal( el, item );
					return;
				}

				el.dataset.revealItem = item;
				observer.observe( el );
			} );
		} );
	}

	// Initialize on DOM ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initStaggerReveal );
	} else {
		initStaggerReveal();
	}

	// Re-initialize on Elementor live edit
	if ( window.elementorFrontend ) {
		TARGETS.forEach( ( { widget } ) => {
			window.elementorFrontend.hooks.addAction(
				`frontend/element_ready/${ widget }.default`,
				initStaggerReveal
			);
		} );
	}
} )();

